import FuelingoFooter2 from "components/Footer";
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <>
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 relative overflow-hidden">
      <div
        className="absolute -top-24 -left-24 w-72 h-72 rounded-full opacity-10 blur-3xl"
        style={{ backgroundColor: "#E53935" }}
      />
      <div
        className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full opacity-10 blur-3xl"
        style={{ backgroundColor: "#E53935" }}
      />

      <div className="relative text-center max-w-lg bg-white  rounded-2xl px-10 py-12">
        <div
          className="mx-auto flex items-center justify-center w-20 h-20 rounded-full"
          style={{ backgroundColor: "#FDECEA" }}
        >
          <svg
            className="w-10 h-10"
            style={{ color: "#E53935" }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>

        <p
          className="mt-6 text-sm font-bold tracking-[0.2em] uppercase"
          style={{ color: "#E53935" }}
        >
          Error 404
        </p>
        <h1 className="mt-2 text-5xl font-extrabold text-gray-900">
          Page Not Found
        </h1>
        <p className="mt-4 text-base text-gray-500">
          The page you're looking for doesn't exist or may have been moved.
          Let's get you back on track.
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-7 py-3 rounded-xl text-white font-semibold shadow-md hover:opacity-90 active:scale-95 transition-all"
          style={{ backgroundColor: "#E53935",color:'white',fontWeight:'300' }}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75"
            />
          </svg>
          Back to Home
        </Link>
      </div>
       
    </div>
     <FuelingoFooter2 />
     </>
  );
};

export default NotFound;
